import React, {useEffect, useState} from "react";
import {useAppText} from "src/commun/composants/AppText";
import styles from "./ListeServices.scss";
import {useAppState} from "src/app/state/StateProvider";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import AppTuile from "src/commun/composants/tuile/AppTuile";
import {ActiveService} from "src/domain/User";
import AppTuilePub from "src/commun/composants/tuile/AppTuilePub";
import {Accordion} from "react-bootstrap";
import AppTuileBandeau from "src/commun/composants/tuile/AppTuileBandeau";


const ListeServices = () => {
  const [{ user, services, bai, favoris,cybersafe }] = useAppState();
  const { tString } = useAppText();

  const [servicesSouscritsMoinsFavoris, setServicesSouscritsMoinsFavoris] = useState<ActiveService[] | undefined>(undefined);

  const [displayPub, setDisplayPub] = useState(false);

  useEffect(() => {
    if (services?.servicesSouscrits && favoris) {
      setServicesSouscritsMoinsFavoris(services?.servicesSouscrits.filter(s => !favoris?.includes(s.serviceCode)));
    }
  }, [services, favoris]);

  useEffect(() => {
    if (services?.publicites && services?.publicites.length > 0) {
      setDisplayPub(true);
    }
  }, [services?.publicites]);

  return (
    <>
      {bai && (
        <AppRow className={styles.containerServiceBandeau}>
          <AppTuileBandeau service={bai}/>
        </AppRow>
      )}

      {cybersafe && (
        <AppRow className={styles.containerServiceBandeau}>
          <AppTuileBandeau service={cybersafe}/>
        </AppRow>
      )}

      <Accordion defaultActiveKey={["0", "1"]} alwaysOpen>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <h2 className="appTitle">
              {(user?.typePersonne !== "Externe") ? tString("page.services.interne.souscrits.title") : tString("page.services.affilie.souscrits.title")}
            </h2>
          </Accordion.Header>
          <Accordion.Body className={styles.containerServicesSouscrits}>

            <AppRow>
              <AppCol xs={{ order: "last" }} lg={{ order: "first" }}>
                {servicesSouscritsMoinsFavoris && servicesSouscritsMoinsFavoris.map((service: ActiveService, index) => (
                  <span key={"service-" + index}>
                  {(index % (displayPub ? 3 : 4) === 0) && (
                    <AppRow key={"service-" + index}>
                      <AppTuile service={servicesSouscritsMoinsFavoris[index]} canSubscribe={false} canAddFavori={true}/>
                      {servicesSouscritsMoinsFavoris[index + 1] ?
                        <AppTuile service={servicesSouscritsMoinsFavoris[index + 1]} canSubscribe={false} canAddFavori={true}/>
                        : <AppCol className={styles.emptyTuileContainer}/>}
                      {servicesSouscritsMoinsFavoris[index + 2] ?
                        <AppTuile service={servicesSouscritsMoinsFavoris[index + 2]} canSubscribe={false} canAddFavori={true}/>
                        : <AppCol className={styles.emptyTuileContainer}/>}
                      {!displayPub && (servicesSouscritsMoinsFavoris[index + 3] ?
                        <AppTuile service={servicesSouscritsMoinsFavoris[index + 3]} canSubscribe={false} canAddFavori={true}/>
                        : <AppCol className={styles.emptyTuileContainer}/>)}
                    </AppRow>
                  )}
                </span>
              ))}
              </AppCol>
              {displayPub && (
                <AppCol lg={3} className={`${styles.containerPub}`}>
                  {services?.publicites.map((pub, index) => <AppTuilePub key={"pub-" + index} pub={pub}/>)}
                </AppCol>
              )}
            </AppRow>
          </Accordion.Body>
        </Accordion.Item>

        {!(user?.typePersonne !== "Externe") && (
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <h2 className="appTitle">{tString("page.services.affilie.nonsouscrits.title")}</h2>
            </Accordion.Header>
            <Accordion.Body className={styles.containerServicesNonSouscrits}>
              {services?.servicesNonSouscrits.map((service: ActiveService, index) => (
                <span key={"service-" + index}>
                {(index % 4 === 0) && (
                  <AppRow>
                    <AppTuile service={services?.servicesNonSouscrits[index]} canSubscribe={true}/>
                    {services?.servicesNonSouscrits[index + 1] ? <AppTuile service={services?.servicesNonSouscrits[index + 1]} canSubscribe={true}/> :
                      <AppCol lg className={styles.emptyTuileContainer}/>}
                    {services?.servicesNonSouscrits[index + 2] ? <AppTuile service={services?.servicesNonSouscrits[index + 2]} canSubscribe={true}/> :
                      <AppCol lg className={styles.emptyTuileContainer}/>}
                    {services?.servicesNonSouscrits[index + 3] ? <AppTuile service={services?.servicesNonSouscrits[index + 3]} canSubscribe={true}/> :
                      <AppCol lg className={styles.emptyTuileContainer}/>}
                  </AppRow>
                )}
              </span>
              ))}
            </Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>

    </>
  );
};

export default ListeServices;